import dayjs from "dayjs"
import { FC } from "react"
import {
  VictoryAxis,
  VictoryBar,
  VictoryChart,
  VictoryContainer,
  VictoryLabel,
} from "victory"
import { colors } from "../../utils/theme"
import { ChartDataPoints } from "../../utils/types"

const RiskAssessmentQuestionnaireChart: FC<{
  id: number
  data: ChartDataPoints[]
  chartLines: string[]
}> = ({ id, data, chartLines }) => {
  return (
    <VictoryChart
      height={285}
      width={385}
      domainPadding={{ x: 75 }}
      padding={{ top: 16, bottom: 118, left: 103, right: 8 }}
      containerComponent={<VictoryContainer style={{ height: "auto" }} />}
    >
      <VictoryAxis
        orientation="left"
        dependentAxis={true}
        tickValues={chartLines}
        tickFormat={(tick) => {
          if (chartLines.includes(tick)) {
            return tick
          } else {
            return ""
          }
        }}
        style={{
          tickLabels: {
            fontFamily: "Lato",
            color: colors.neutral.asphalt,
            fontSize: 12,
            fontWeight: 400,
          },
          grid: { stroke: colors.neutral.clay },
          axis: { stroke: colors.neutral.clay },
        }}
      />
      <VictoryAxis
        orientation="right"
        dependentAxis={true}
        tickComponent={<></>}
        tickLabelComponent={<></>}
        style={{
          axis: { stroke: colors.neutral.clay },
        }}
      />
      <VictoryAxis
        orientation="bottom"
        tickComponent={<></>}
        tickLabelComponent={<></>}
        style={{
          axis: { stroke: colors.neutral.clay },
        }}
      />
      <VictoryAxis
        orientation="bottom"
        offsetY={120}
        tickLabelComponent={
          <VictoryLabel angle={-75} textAnchor="end" verticalAnchor="middle" />
        }
        style={{
          tickLabels: {
            fontFamily: "Lato",
            color: colors.neutral.asphalt,
            fontSize: 12,
            fontWeight: 400,
            padding: 10,
          },
          axis: { stroke: "transparent" },
          ticks: { stroke: "transparent" },
        }}
      />
      <VictoryBar
        data={data}
        x={(datum) => dayjs(datum.x).format("MMM D")}
        cornerRadius={{ top: 6, bottom: 6 }}
        barWidth={16}
        style={{
          data: { fill: colors.tertiary.orange },
        }}
      />
    </VictoryChart>
  )
}

export default RiskAssessmentQuestionnaireChart
